import { useMemo } from 'react'
import moment from 'moment'
import { constants, dateFormatter } from 'helpers'
import { getTicketPriceString } from '../utils'

const {
  EVENT_CONSTANTS: { STATUS },
} = constants

const newEventView = true

const useEventData = ({ event, childEvent }) => {
  return useMemo(() => {
    const { status, startTime } = childEvent
    const { format, ticketPrice } = event

    const isCancelled = status === STATUS.ARCHIVED
    const isCompleted = status === STATUS.COMPLETED || isCancelled
    const isActive = status === STATUS.STARTED

    const startDate = moment(startTime)
    const endDate = moment(startTime).add(
      format.lobbyLength + format.rounds * (format.roundLength + format.matchLength),
      'seconds'
    )
    const timezone = dateFormatter.getCurrentTimeZone().toLowerCase()

    return {
      ...childEvent,
      isCancelled,
      isCompleted,
      isActive,
      startDateString: `${startDate.format('ddd, MMM D')}`,
      timeString: `${startDate.format('h:mm A')} ${
        newEventView ? '' : ` - ${endDate.format('h:mm a')} (${timezone})`
      }`,
      ticketPriceString: getTicketPriceString(ticketPrice),
    }
  }, [event, childEvent])
}

export default useEventData
